<template>
  <div style="margin-top: 60px">
    <div class="newsbanner">
      <div class="newsbannerp1"><span>资讯热点</span></div>
      <div class="newsbannerp2"><span>news</span></div>
    </div>
    <div class="content">
      <div class="showMvinfo">
        <div class='newList1' v-for="itemm in firstPage">
          <div class='newListL'>
            <router-link :to="{ path: 'NewsPage/NewsinfoPage', query: { theInfoNum: itemm.id ,passPageNum:hoverId} }">
              <p class='newListL1'>{{itemm.name}}</p>
            </router-link>
            <p class='newListL2'>{{itemm.createTimeStr}}</p>
            <p class='newListL3'>{{itemm.summary}}</p>
          </div>
          <div class='newListR'>
            <img :src='itemm.coverImg' alt='' onerror="src='../static/resource/errorpic.png'"/>
          </div>
        </div>
      </div>
      <div class="newsPagunationBox">
        <div class="newsPagunation">
          <img :src="moveLeftarrowpic" alt="" class="arrowL" @click="moveRight" v-show="ifshowthearrow"/>
          <div class="numBox">
            <ul class="numBoxul" :class="{'positonActive':thepositionnum==0}" :style="tStyle">
              <li class='numBoxulli'
                  v-for="index in thePageNum"
                  @click="turntopage"
                  :data-id="index"
                  :class="{'active': hoverId == index}"
              >{{(index+1)}}
              </li>
            </ul>
          </div>
          <img :src="moveRightarrowpic" alt="" class="arrowR" @click="moveLeft" v-show="ifshowthearrow"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Request from '../common/request.js';

  var _this;
  var request = new Request();
  var arr = [];
  var num;
  var pagenum;
  var pN = []
  var theSelectedPage = 0;
  var movenum = 0;
  var pagenums;

  export default {
    name: 'NewsPage',
    data: function () {
      return {
        firstPage: arr,
        thePageNum: [],
        hoverId: 0,
        tStyle: "left: -" + 450 * movenum + "px",
        moveLeftarrowpic: '../static/resource/arrowL.png',
        moveRightarrowpic: '../static/resource/arrowR.png',
        thepositionnum: 1,
        ifshowthearrow: false
      }
    },
    methods: {
      turntopage: function (ev) {
        this.hoverId = ev.target.innerHTML - 1;
        theSelectedPage = ev.target.innerHTML - 1;
        this.getFourMsg(ev.target.innerHTML);
      },
      backturntopage: function (num) {
        this.hoverId = num - 1;
        theSelectedPage = num - 1;
        this.getFourMsg(num);
      },
      moveLeft: function () {
        if (movenum < pagenums - 1) {
          movenum++;
        }
        if (pagenum > 9) {
          var ulwidth = (46 + 4) * pagenum
          $('.numBoxul').width(ulwidth);
        }
        if (pagenum > 9) {
          this.thepositionnum = 0
        }
        this.tStyle = "left: -" + (450 * movenum) + "px";
      },
      moveRight: function () {
        if (movenum > 0) {
          movenum--;
        }
        if (pagenum > 9) {
          var ulwidth = (46 + 4) * pagenum
          $('.numBoxul').width(ulwidth);
        }
        if (pagenum > 9) {
          this.thepositionnum = 0
        }
        this.tStyle = "left: -" + (450 * movenum) + "px";
      },
      getFourMsg: function (num) {
        request.get({
          url: '/mengyang/information/getPortalInformationsList',
          params: {
            page: num,
            number: 4
          },
          callback(data) {
            if (data.data.length > 0) {
              _this.ifshowthearrow = true;
            }
            arr = [];
            for (let i = 0; i < data.data.length; i++) {
              if (undefined == data.data[i].filemImg) {
                data.data[i].filemImg = '';
              }
            }
            data.data.forEach(function (ele) {
              if (ele.name.length > 25) {
                ele.name = ele.name.substring(0, 25) + '...'
              }
              if (ele.summary.length > 78) {
                ele.summary = ele.summary.substring(0, 78) + '...'
              }
              ele.createTimeStr = ele.createTimeStr.split(' ')[0]
              arr.push(ele)
            })
            _this.firstPage = arr;
            pagenum = Math.ceil(data.totalNumber / 4);
            pN = []
            for (var b = 0; b < pagenum; b++) {
              pN[b] = b;
            }
            _this.thePageNum = pN;
            theSelectedPage = 0;
            movenum = 0;
            pagenums = Math.ceil(pagenum / 9);
          }
        })
      }
    },
    mounted: function () {
      _this = this;
      //门户网站获取资讯列表接口
      this.getFourMsg(1);
      this.hoverId = theSelectedPage;
    },
  }

</script>

<style>
  .newsbanner {
    height: 224px;
    width: 100%;
    background: #74e5fe;
    text-align: center;
  }

  .newsbannerp1 {
    color: #666666;
    font-size: 48px;
    font-family: myFont;
    height: 60px;
    width: 100%;
    padding-top: 60px;
  }

  .newsbannerp2 {
    color: #666666;
    font-size: 24px;
    font-family: myFont;
    height: 50px;
    width: 100%;
  }

  .theBottom {
    position: fixed;
    bottom: 0;
    height: 40px;
    width: 100%;
    background: #282828;
    z-index: 100;
  }

  .theBottom img {
    height: 40px;
  }

  .content {
    width: 1204px;
    height: auto;
    margin: 0 auto;
  }

  .showMvinfo {
    width: 1204px;
    height: 906px;
    margin-top: 40px;
  }

  .newList1 {
    height: 216px;
    width: 1204px;
    box-sizing: border-box;
    border: 4px solid #cccccc;
    margin-top: 15px;
  }

  .newsPagunationBox {
    box-sizing: border-box;
    padding-top: 40px;
    height: 172px;
  }

  .newsPagunation {
    height: 40px;
    width: 566px;
    margin: auto;
  }

  .newListL {
    width: 988px;
    height: 208px;
    float: left;
  }

  .newListR {
    width: 208px;
    height: 208px;
    float: left;
    box-sizing: border-box;
    padding: 6px;
  }

  .newListR > img {
    width: 196px;
    height: 196px;
  }

  .newListL1 {
    color: #000000;
    font-size: 28px;
    font-family: myFont;
    margin-left: 40px;
    margin-top: 34px;
    cursor: pointer;
    width: 880px;
    height: 37px;
  }

  .newListL1 a:hover {
    color: red;
  }

  .newListL1:hover {
    color: red;
  }

  .newListL2 {
    color: #969696;
    font-size: 22px;
    font-family: myFont;
    margin-left: 40px;
    margin-top: 14px;
  }

  .newListL3 {
    color: #969696;
    font-size: 22px;
    font-family: myFont;
    margin-left: 40px;
    margin-top: 20px;
    width: 880px;
    height: 58px;
    word-break:break-all;
    overflow: hidden;
  }

  .arrowL {
    cursor: pointer;
    float: left;
  }

  .arrowR {
    cursor: pointer;
    float: left;
    margin-left: 8px;
  }

  .numBox {
    position: relative;
    float: left;
    width: 454px;
    height: 40px;
    margin-left: 12px;
    text-align: center;
    overflow: hidden;
  }

  .numBoxul {
    display: inline-block;
    height: 40px;
    text-align: center;
    transition: .5s;
  }

  .numBox li {
    float: left;
    width: 46px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ecf1f0;
    margin-left: 4px;
  }

  .numBox li:hover {
    color: white;
    background: #74e5fe;
  }

  .numBoxulli:hover, .numBox
  .active {
    cursor: pointer;
    background-color: #74e5fe;
  }

  .positonActive {
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/newsPage.vue